import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useCallback, useEffect, useState } from 'react';
import { observer } from 'mobx-react-lite';
import { useTranslation } from 'react-i18next';
import classNames from 'classnames';
import moment from 'moment-timezone';
import { $auth } from 'ziphy-web-shared/basic/entities/auth';
import { LegacyMultiSelect, Switcher } from 'ziphy-web-shared/basic/lib/forms/fields';
import { DateNow, DateRewind } from 'ziphy-web-shared/basic/lib/functional';
import { WithLoaderWrapper } from 'ziphy-web-shared/basic/lib/loaders';
import { formatDate } from 'ziphy-web-shared/basic/utils/time';
import { $calendar } from '../../Calendar.store';
import styles from './Header.module.scss';
const Header = ({ isLoading, className }) => {
    const { t } = useTranslation();
    const [workingTime, setWorkingTime] = useState(null);
    const now = moment.tz($calendar.timezone);
    const today = now.clone().startOf('day');
    const changeWeekHandle = useCallback(({ begin, end }) => {
        $calendar.SET_RANGE({ _begin: begin, _end: end });
        if ($calendar.isAsDay) {
            $calendar.SET_SELECTED_DAY(begin.isBefore(today) ? today : begin);
        }
    }, [today, $calendar.isAsDay]);
    useEffect(() => {
        var _a;
        if (!$calendar.schedule[$calendar.selectedDay]) {
            return;
        }
        const { begin, end } = (_a = $calendar.schedule[$calendar.selectedDay]) === null || _a === void 0 ? void 0 : _a.workingTime;
        if (begin && end) {
            const result = `${formatDate(begin, { format: 'time' })} — ${formatDate(end, { format: 'time' })}`;
            setWorkingTime(result);
        }
    }, [$calendar.schedule, $calendar.selectedDay]);
    return (_jsx("div", Object.assign({ className: classNames(styles.header, $calendar.isMobile && styles.isMobile, className) }, { children: _jsx("div", Object.assign({ className: "container" }, { children: _jsxs("div", Object.assign({ className: styles.inner }, { children: [_jsxs("div", Object.assign({ className: styles.datetime }, { children: [_jsx("div", Object.assign({ className: styles.date }, { children: moment($calendar.selectedDay).isSame(now, 'day') ? (_jsx(DateNow, { timezone: $calendar.timezone })) : (formatDate($calendar.selectedDay, { format: 'dateNoYear' })) })), _jsx(WithLoaderWrapper, Object.assign({ loader: 'bubble', isLoading: $calendar.isAsDay && isLoading, mode: 'reload', className: styles.workingTime, loaderClassName: styles.workingTimeLoader }, { children: (workingTime === null || workingTime === void 0 ? void 0 : workingTime.length) ? workingTime : t('label.not_working_day') }))] })), _jsxs("div", Object.assign({ className: styles.controls }, { children: [!$calendar.isMobile && (_jsx(Switcher, { active: $calendar.viewMode, items: [
                                    { id: 'day', title: t('label.day') },
                                    { id: 'week', title: t('label.week') },
                                ], onChange: (value) => {
                                    $calendar.SET_VIEW_MODE(value);
                                } })), _jsx(DateRewind, { isDay: $calendar.isAsDay, begin: $calendar.begin, end: $calendar.end, onChange: changeWeekHandle, timezone: $calendar.timezone, weekType: $calendar.weekType }), _jsx("div", Object.assign({ className: styles.filter }, { children: _jsx(LegacyMultiSelect, { field: {
                                        value: $calendar.filterByPractice,
                                        onChange: (v) => $calendar.SET_FILTER(v[0]),
                                    }, items: [
                                        { id: 0, text: t('label.all_practices') },
                                        ...$auth.availablePractices.map((x) => ({ id: x.id, text: x.name })),
                                    ], direction: ['bottom'] }) }))] }))] })) })) })));
};
export default observer(Header);
